import React, { useState, useEffect } from "react";
import "./layout.css";
import Sidebar from "../sidebar/Sidebar";
import TopNav from "../topnav/TopNav";
import { useLocation } from "react-router-dom";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";

const drawerWidth = 15;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    backgroundColor: theme?.palette?.background?.default || "#f4f5fd",
  },
  Content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: "100vh",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: "100%",
    overflowX: "hidden",
  },
  contentShift: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // Removed marginLeft here because Sidebar is a flex items that takes space when open
    // Flexbox handles the positioning naturally.
  },
}));
const Layout = ({ children }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const [open, setOpen] = useState(!isMobile);

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const isShifted = open && !isMobile;

  return (
    <div className={`layout ${classes.root}`}>
      <Sidebar
        open={open}
        location={location}
        onClose={() => setOpen(false)}
        variant={isMobile ? "temporary" : "persistent"}
      />
      <div
        className={`${classes.Content} ${isShifted ? classes.contentShift : ""}`}
      >
        <div className="layout__content">
          <TopNav handleDrawerToggle={handleDrawerToggle} toggled={open} />
          <div className="layout__content-main">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
